/**
 * Created by gengqingqing on 2017/8/6.
 */
import http from '../libs/http'

export const getTables = ({ project_id }) => {
  return http.get({
    url: '/api/tables',
    data: {
      params: {
        project_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const newTable = options => {
  const { project_id, app_id, table_name, name, desc, fields } = options;
  const body = { project_id, app_id, table_name, name, desc, fields, }
  return http.post({
    url: '/api/table',
    data: body
  }).then((res) => {
    return res;
  })
};

export const updateTable = (options) => {
  const { app_id, table_id, project_id, table_name, name, desc, fields, copyFlag, editType, editFields, primaryKeyArray, } = options;
  const body = { app_id, table_id, project_id, table_name, name, desc, fields, copyFlag, editType, editFields, primaryKeyArray, };
  return http.put({
    url: '/api/table',
    data: body
  }).then((res) => {
    return res;
  })
};

export const deleteTable = ({ project_id, table_id }) => {
  return http.delete({
    url: '/api/table',
    data: {
      params: {
        project_id,
        table_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const exportTableToExcel = options => {
  const { project_id, table_name } = options;
  const params = { project_id, table_name };
  return http.get({
    url: '/api/table/data',
    data: { params }
  }).then(res => {
    return res.body ? res.body.data : {}
  });
}



// WEBPACK FOOTER //
// ./src/apis/table_apis.js